import React from 'react';

import { useIntl } from 'react-intl';

import { useCreateValidatorAccount } from 'src/features/validatorAccounts/api/useCreateValidatorAccount';
import { LIST_VALIDATOR_ACCOUNTS_RESOURCE } from 'src/features/validatorAccounts/api/useListValidatorAccounts';
import ValidatorAccountFormModal from 'src/features/validatorAccounts/components/forms/ValidatorAccountFormModal';
import { validatorAccountsMessages } from 'src/features/validatorAccounts/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { ICON_MAP } from 'src/utils/constants';
import { useParking } from 'src/providers/ParkingProvider';

interface CreateValidatorAccountFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateValidatorAccountFormModal<TData>({ className }: CreateValidatorAccountFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateValidatorAccount({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_VALIDATOR_ACCOUNTS_RESOURCE] });
            toast({
                title: formatMessage(validatorAccountsMessages.createValidatorAccountSuccess),
                description: formatMessage(validatorAccountsMessages.createValidatorAccountSuccessDescription),
            });
        },
    });

    return (
        <ValidatorAccountFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ parkingId, ...values }, { onSuccess, onError })}
            title={formatMessage(validatorAccountsMessages.newValidatorAccount)}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(validatorAccountsMessages.addValidatorAccountModalSubtitle)}
        />
    );
}

export default CreateValidatorAccountFormModal;
